import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ActivityFrequencySelectorStyles";
import { appliancesActions } from "../_actions";

export default class ApplianceNavigation extends Component {
  render() {
    const { tab } = this.props.appliances;

    return (
      <div className={css(styles.selectorWrapper)}>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            tab !== "used"
              ? this.props.dispatch(appliancesActions.setTab("used"))
              : null
          }
        >
          <p
            className={css(styles.selector, tab === "used" && styles.selected)}
          >
            Most Used
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            tab !== "costly"
              ? this.props.dispatch(appliancesActions.setTab("costly"))
              : null
          }
        >
          <p
            className={css(
              styles.selector,
              tab === "costly" && styles.selected
            )}
          >
            Most Costly
          </p>
        </span>
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            tab !== "all"
              ? this.props.dispatch(appliancesActions.setTab("all"))
              : null
          }
        >
          <p className={css(styles.selector, tab === "all" && styles.selected)}>
            All
          </p>
        </span>
      </div>
    );
  }
}
